import { MultiSuggestRouteItem } from '@lp/features/MultiSuggest';
import { RouteItem } from './RouteItem';

type RouteListProps = {
  list: MultiSuggestRouteItem[];
};

export const RouteList = ({ list }: RouteListProps) => {
  if (!list.length) {
    return <span className="text-l-sb text-base-10">N/A</span>;
  }

  return (
    <div className="flex flex-col gap-3">
      {list.map((item) => (
        <RouteItem key={`${item.providerType}-${item.routeDurationInMs}`} route={item} />
      ))}
    </div>
  );
};
